<template>
  <b-card>
    <h1>动态组件</h1>
    <el-tabs v-model="tabActive" type="card" @tab-click="onTabClick">
      <el-tab-pane
        :label="tab.title"
        :name="tab.id"
        v-for="(tab, index) in tabData"
        :key="index"
      >
        <el-collapse v-model="collapseActives" @change="onCollapseChange">
          <el-collapse-item
            :title="group.title"
            :name="group.id"
            v-for="(group, index) in tab.childrens"
            :key="index"
          >
            <!-- 表单 -->
            <el-form
              ref="form"
              :model="formData['' + tab.id + group.id]"
              label-width="80px"
              label-position="top"
            >
              <el-row :gutter="20">
                <el-col
                  :span="8"
                  v-for="(item, index) in group.childrens"
                  :key="index"
                >
                  <el-form-item :label="item.title">
                    <el-select
                      v-if="item.elemt === 'select'"
                      v-model="item.value"
                      clearable
                      filterable
                      :disabled="item.props.disabled"
                      :placeholder="'请选择' + item.title"
                      :size="item.props.size"
                      style="width:100%;"
                    >
                      <el-option label="测试"></el-option>
                    </el-select>
                    <el-cascader
                      v-else-if="item.elemt === 'cascader'"
                      :props="props"
                      :size="item.props.size"
                    ></el-cascader>
                    <component
                      v-else
                      :is="`el-${item.elemt}`"
                      v-model="item.value"
                      :disabled="item.props.disabled"
                      clearable
                      :size="item.props.size"
                      :type="item.props.type"
                      style="width:100%;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
    </el-tabs>
  </b-card>
</template>
<script>
let id = 0
export default {
  data() {
    return {
      tabActive: '1',
      collapseActives: [],
      tabData: [
        {
          title: '基本信息',
          id: '1',
          value: null,
          childrens: [
            {
              title: '主信息',
              id: '1',
              childrens: [
                {
                  title: '级别',
                  id: 'A0310',
                  value: '',
                  elemt: 'input',
                  props: {
                    size: 'mini',
                    disabled: false,
                  },
                },
                {
                  title: '类别',
                  id: 'A0211',
                  value: '',
                  elemt: 'input',
                  props: {
                    type: 'textarea',
                    size: 'small',
                  },
                },
              ],
            },
            {
              title: '鉴定信息',
              id: '2',
              childrens: [
                {
                  title: '民族',
                  id: 'Z0002',
                  value: '',
                  elemt: 'select',
                  props: {
                    size: 'mini',
                    disabled: false,
                  },
                },
                {
                  title: '鉴藏印记',
                  id: 'A1305',
                  value: '',
                  elemt: 'cascader',
                  props: {
                    size: 'mini',
                    disabled: false,
                  },
                },
              ],
            },
          ],
        },
        {
          title: '配置管理',
          id: '2',
          childrens: [
            {
              title: '鉴定信息',
              id: '1',
            },
          ],
        },
      ],
      formData: {},
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            const nodes = Array.from({ length: level + 1 }).map(() => ({
              value: ++id,
              label: `选项${id}`,
              leaf: level >= 2,
            }))
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes)
          }, 1000)
        },
      },
      options: [
        {
          value: 'zhinan',
          label: '指南',
          children: [
            {
              value: 'shejiyuanze',
              label: '设计原则',
              children: [
                {
                  value: 'yizhi',
                  label: '一致',
                },
                {
                  value: 'fankui',
                  label: '反馈',
                },
                {
                  value: 'xiaolv',
                  label: '效率',
                },
                {
                  value: 'kekong',
                  label: '可控',
                },
              ],
            },
            {
              value: 'daohang',
              label: '导航',
              children: [
                {
                  value: 'cexiangdaohang',
                  label: '侧向导航',
                },
                {
                  value: 'dingbudaohang',
                  label: '顶部导航',
                },
              ],
            },
          ],
        },
        {
          value: 'zujian',
          label: '组件',
          children: [
            {
              value: 'basic',
              label: 'Basic',
              children: [
                {
                  value: 'layout',
                  label: 'Layout 布局',
                },
                {
                  value: 'color',
                  label: 'Color 色彩',
                },
                {
                  value: 'typography',
                  label: 'Typography 字体',
                },
                {
                  value: 'icon',
                  label: 'Icon 图标',
                },
                {
                  value: 'button',
                  label: 'Button 按钮',
                },
              ],
            },
            {
              value: 'form',
              label: 'Form',
              children: [
                {
                  value: 'radio',
                  label: 'Radio 单选框',
                },
                {
                  value: 'checkbox',
                  label: 'Checkbox 多选框',
                },
                {
                  value: 'input',
                  label: 'Input 输入框',
                },
                {
                  value: 'input-number',
                  label: 'InputNumber 计数器',
                },
                {
                  value: 'select',
                  label: 'Select 选择器',
                },
                {
                  value: 'cascader',
                  label: 'Cascader 级联选择器',
                },
                {
                  value: 'switch',
                  label: 'Switch 开关',
                },
                {
                  value: 'slider',
                  label: 'Slider 滑块',
                },
                {
                  value: 'time-picker',
                  label: 'TimePicker 时间选择器',
                },
                {
                  value: 'date-picker',
                  label: 'DatePicker 日期选择器',
                },
                {
                  value: 'datetime-picker',
                  label: 'DateTimePicker 日期时间选择器',
                },
                {
                  value: 'upload',
                  label: 'Upload 上传',
                },
                {
                  value: 'rate',
                  label: 'Rate 评分',
                },
                {
                  value: 'form',
                  label: 'Form 表单',
                },
              ],
            },
            {
              value: 'data',
              label: 'Data',
              children: [
                {
                  value: 'table',
                  label: 'Table 表格',
                },
                {
                  value: 'tag',
                  label: 'Tag 标签',
                },
                {
                  value: 'progress',
                  label: 'Progress 进度条',
                },
                {
                  value: 'tree',
                  label: 'Tree 树形控件',
                },
                {
                  value: 'pagination',
                  label: 'Pagination 分页',
                },
                {
                  value: 'badge',
                  label: 'Badge 标记',
                },
              ],
            },
            {
              value: 'notice',
              label: 'Notice',
              children: [
                {
                  value: 'alert',
                  label: 'Alert 警告',
                },
                {
                  value: 'loading',
                  label: 'Loading 加载',
                },
                {
                  value: 'message',
                  label: 'Message 消息提示',
                },
                {
                  value: 'message-box',
                  label: 'MessageBox 弹框',
                },
                {
                  value: 'notification',
                  label: 'Notification 通知',
                },
              ],
            },
            {
              value: 'navigation',
              label: 'Navigation',
              children: [
                {
                  value: 'menu',
                  label: 'NavMenu 导航菜单',
                },
                {
                  value: 'tabs',
                  label: 'Tabs 标签页',
                },
                {
                  value: 'breadcrumb',
                  label: 'Breadcrumb 面包屑',
                },
                {
                  value: 'dropdown',
                  label: 'Dropdown 下拉菜单',
                },
                {
                  value: 'steps',
                  label: 'Steps 步骤条',
                },
              ],
            },
            {
              value: 'others',
              label: 'Others',
              children: [
                {
                  value: 'dialog',
                  label: 'Dialog 对话框',
                },
                {
                  value: 'tooltip',
                  label: 'Tooltip 文字提示',
                },
                {
                  value: 'popover',
                  label: 'Popover 弹出框',
                },
                {
                  value: 'card',
                  label: 'Card 卡片',
                },
                {
                  value: 'carousel',
                  label: 'Carousel 走马灯',
                },
                {
                  value: 'collapse',
                  label: 'Collapse 折叠面板',
                },
              ],
            },
          ],
        },
        {
          value: 'ziyuan',
          label: '资源',
          children: [
            {
              value: 'axure',
              label: 'Axure Components',
            },
            {
              value: 'sketch',
              label: 'Sketch Templates',
            },
            {
              value: 'jiaohu',
              label: '组件交互文档',
            },
          ],
        },
      ],
    }
  },
  watch: {
    formData(val) {
      console.log(val)
    },
  },
  created:{

  },
  methods: {
    onTabClick() {
      console.log('onTabClick-->')
    },
    onCollapseChange() {},
  },
}
</script>
